// extracted by mini-css-extract-plugin
export default {"root":"river-search_root__rk-tZ","input":"river-search_input__mqllo","outlined":"river-search_outlined__z8ap-","searchIcon":"river-search_searchIcon__iWtap"};